<div class="shared-status">
  <span *ngIf="showCurrentStatus&&refId&&currentStatus" style="display:inline-block;">
  {{currentStatus | titleCase }}
  </span>
  <span *ngIf="!currentStatus" style="display:inline-block;">
  Not Available
  </span>

  <span style="padding-left:10px;">
  <button *ngIf="refId&&currentStatus!=ApprovalStatusType.ActionRequired&&currentStatus!=ApprovalStatusType.Pending&&currentStatus!=ApprovalStatusType.Saved"
          pButton class="action-icon" icon="fa fa-external-link" [pTooltip]="approvalTooltip" tooltipPosition="top"
          (click)="onClickShowApprovalStatusDialog(transaction, refId, showStatusInDialog, showStatusOnPage, emitStatus)">
  </button>
  <button *ngIf="refId&&currentStatus==ApprovalStatusType.ActionRequired||hasSubmissionError"
          pButton class="icon-negative" icon="fa fa-exclamation-triangle" [pTooltip]="validationTooltip" tooltipPosition="top"
          (click)="onClickShowValidationError(transaction, refId, showStatusInDialog, showStatusOnPage, emitStatus)">
  </button>
</span>
</div>

<app-approval-status [request]="approvalStatusRequest" [managingOrgId]="managingOrgId"></app-approval-status>
<app-txn-error-code [request]="txnErrorCodeRequest" [managingOrgId]="managingOrgId"></app-txn-error-code>
